"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var util_1 = require("@aperza/util");
var Counter_1 = __importDefault(require("../common/Counter"));
var prop_types_1 = __importDefault(require("prop-types"));
var graphql_tag_1 = __importDefault(require("graphql-tag"));
var client_1 = require("@apollo/client");
var QUERY = graphql_tag_1.default(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query CartBadgeQuery {\n    viewer {\n      id\n      cartBadge {\n        approvalFlag\n        totalPurchaseNumber\n      }\n    }\n  }\n"], ["\n  query CartBadgeQuery {\n    viewer {\n      id\n      cartBadge {\n        approvalFlag\n        totalPurchaseNumber\n      }\n    }\n  }\n"])));
var appConfig = util_1.AppService.appConfig();
var CartBadge = function (props) {
    var url = '#';
    var totalPurchaseNumber = undefined;
    var _a = client_1.useLazyQuery(QUERY), getData = _a[0], _b = _a[1], loading = _b.loading, error = _b.error, data = _b.data, refetch = _b.refetch, fetchMore = _b.fetchMore;
    var cartBadge = util_1.ObjectUtil.get(props.viewer, 'viewer.cartBadge');
    if (cartBadge) {
        url = "https://order" + appConfig.baseComDomain + "/cart";
        totalPurchaseNumber = cartBadge.totalPurchaseNumber;
    }
    return (react_1.default.createElement("a", { className: "cartPict", href: url, target: "_self" },
        react_1.default.createElement("div", { className: "util-icon cart" }),
        totalPurchaseNumber > 0 && react_1.default.createElement(Counter_1.default, { top: true, count: totalPurchaseNumber })));
};
CartBadge.propTypes = {
    viewer: prop_types_1.default.shape({
        id: prop_types_1.default.string,
        cartBadge: prop_types_1.default.shape({
            totalPurchaseNumber: prop_types_1.default.number,
        }),
    }),
};
exports.default = CartBadge;
var templateObject_1;
